import { Component, Inject, OnDestroy } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { PropertiesService, PropertyOpenDataDpe, RealProperty } from '@eemo/api-client';
import { Subscription } from 'rxjs';

import { ActionDoneType } from '@/enums/ActionDoneType.enum';
import { DateFormatPipe } from '@/extensions/datePipe';
import { DecimalFormatPipe } from '@/extensions/DecimalPipe';
import { AlertService } from '@/services/alert.service';
import { AppConfigService } from '@/services/app-config.service';
import { NgTemplateOutlet } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatRadioModule } from '@angular/material/radio';
import { ModalBaseComponent } from '../base/modal-base/modal-base.component';

export class PropertyDpeChoiceDialogData {
  property: RealProperty;
  dpeList: PropertyOpenDataDpe[];
}

@Component({
  selector: 'app-property-dpe-choice-dialog',
  templateUrl: './property-dpe-choice-dialog.component.html',
  styleUrls: ['./property-dpe-choice-dialog.component.scss'],
  standalone: true,
  imports: [
    ModalBaseComponent,
    NgTemplateOutlet,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatDividerModule,
    DateFormatPipe,
    DecimalFormatPipe
  ]
})
export class PropertyDpeChoiceDialogComponent implements OnDestroy {
  sub = new Subscription();
  dialogTitle: string;
  isLoading = false;

  get form_dpeNumber() {
    return this.form.get('dpeNumber') as FormControl<string>;
  }

  form = this.fb.group({
    dpeNumber: [null, Validators.required]
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PropertyDpeChoiceDialogData,
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<PropertyDpeChoiceDialogComponent>,
    private propertiesService: PropertiesService,
    private alertService: AlertService,
    private appConfigService: AppConfigService
  ) {
    this.dialogTitle = 'propertyDpeChoiceDialog.title';
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  onSubmit(): void {
    this.isLoading = true;
    if (this.form.valid) {
      if (this.form_dpeNumber.value === 'NONE') {
        // delete dpe
        this.sub = this.propertiesService.deleteRealPropertyOpenDataDpe(this.data.property.uid).subscribe({
          next: () => {
            this.isLoading = false;
            this.alertService.success('Récupération du DPE annulée');
            this.dialogRef.close(true);
          },
          error: () => {
            this.isLoading = false;
          }
        });
      } else {
        // select the DPE
        this.sub = this.propertiesService
          .selectRealPropertyOpenDataDpe(this.data.property.uid, this.form_dpeNumber.value)
          .subscribe({
            next: () => {
              this.isLoading = false;
              this.alertService.success(`Récupération du DPE ${this.form_dpeNumber.value} en cours`);
              this.appConfigService.triggerActionDone(ActionDoneType.OPENDATA_SYNC);
              this.dialogRef.close(true);
            },
            error: () => {
              this.isLoading = false;
            }
          });
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
